module.exports = __webpack_public_path__ + "media/A24.531205d0.mp3";